import type { RootState } from '..';

export const clanWarsSelector = (state: RootState) => state.ReducerClanWars;
export const clanWarsCurrentStageSelector = (state: RootState) => state.ReducerClanWars.stages.currentStage;
